import React, { useEffect } from "react";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import { Provider, useDispatch } from "react-redux";
import { App as AntdApp, ConfigProvider } from "antd";
import store from "./redux/store";
import { initializeAuth } from "./redux/authentication/authSlice";
import ThemeToggle from './theme/ThemeToggle';
import { useTheme } from './theme/ThemeContext';

import Renderer from './pages/Renderer.js';
import HeadlessRenderer from './pages/HeadlessRenderer.js';

const router = createBrowserRouter(
  [{
    path: `${process.env.PUBLIC_URL}/Renderer/:TokenVariant`,
    element: <Renderer />,
  },
  {
    path: `${process.env.PUBLIC_URL}/Renderer`,
    element: <HeadlessRenderer />,
  },],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);

// Componente che include il tema e la navigazione
const ThemedApp = () => {
  const dispatch = useDispatch();
  const { isDarkMode, toggleTheme } = useTheme();

  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);

  return (
    <div className="App">
      <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 1000 }}>
        <ThemeToggle isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
      </div>
      <RouterProvider router={router} />
    </div>
  );
};

const App = () => (
  <Provider store={store}>
    <ConfigProvider>
      <AntdApp>
        <ThemedApp />
      </AntdApp>
    </ConfigProvider>
  </Provider>
);

export default App;
